/**
 * @fileoverview POST handler for the "/apps/:app_group_id/charts/uninstall" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { appsAppGroupIdChartsUninstallCacheKeys } from "./constants";
import type { PostAppsAppGroupIdChartsUninstallProps, AppsAppGroupIdChartsUninstallResult } from "./types";

export const postAppsAppGroupIdChartsUninstall = reactQueryMutationAdapter(
  appsAppGroupIdChartsUninstallCacheKeys,
  (props: PostAppsAppGroupIdChartsUninstallProps): Promise<AppsAppGroupIdChartsUninstallResult> => {
    return fetch(`/apps/${props.appGroupId}/charts/uninstall`, "POST", {
      start_date: props.startDate?.toString(),
      end_date: props.endDate?.toString(),
      app_ids: props.appIds,
    });
  }
);
